<div class="diagnosis-container">
  <div><strong>The Diagnosis Results:</strong></div>
  <div class="img-area">
    <img [src]="imageUrl" alt=""/>
  </div>
  <div class="tongue" *ngFor="let result of results">
    <div class="tongue-name">
      <span *ngIf="result.location !== 0">{{result.location | tongueLocation:'en'}}</span>
      {{result.tongueName}}
    </div>
    <div class="symptom" *ngFor="let symptom of result.symptoms">{{symptom}}</div>
  </div>
  <div class="close-button-area">
    <button pButton (click)="closeDiagnosisDisplayer()">Close</button>
  </div>
</div>
